export const utilityColors = {
  utilityBackground: '#F1EDE7',
  utilityInformationBackground: '#e5f0ed',
  utilityText: '#3C3D41',
  utilityWhite: '#FFF',
} as const;
